/** DTOs' keys from `project` module */
export enum ProjectDtoKeysEnum {
  /** Deadline delay response body */
  DEADLINE_DELAY_REQUEST_FIND_DTO = 'project/deadline-delay-request-find.dto',
  /** Deadline delay create API request body */
  DEADLINE_DELAY_REQUEST_FORM_DTO = 'project/deadline-delay-request-form.dto',
  /** Project templates list API query parameters */
  PROJECT_TEMPLATE_LIST_QUERY_DTO = 'project/project-template-list-query.dto',
  /** Accessible projects API query parameters */
  PROJECT_ACCESSIBLE_QUERY_DTO = 'project/project-accessible-query.dto',
  /** Project file response body */
  PROJECT_FILE_FIND_DTO = 'project/project-file-find.dto',
  /** Project files attachement API request body */
  PROJECT_ADD_FILES_DTO = 'project/project-add-files.dto',
  /** Project create API request body */
  PROJECT_CREATE_DTO = 'project/project-create.dto',
  /** Project deal assignment API request body */
  PROJECT_DEAL_ASSIGN_DTO = 'project/project-deal-assign.dto',
  /** Project's deal APIs URL paramaters */
  PROJECT_DEAL_PARAMS_DTO = 'project/project-deal-params.dto',
  /** Project's deals list API query parameters */
  PROJECT_DEAL_QUERY_DTO = 'project/project-deal-query.dto',
  /** Projects response body */
  PROJECT_FIND_DTO = 'project/project-find.dto',
  /** Project update API request body */
  PROJECT_FORM_DTO = 'project/project-form.dto',
  /** Project HD tasks widget API query parameters */
  PROJECT_HELPDESK_TASKS_QUERY_DTO = 'project/project-helpdesk-tasks-query.dto',
  /** Project HD tasks assign API request body */
  PROJECT_HELPDESK_TASKS_FORM_DTO = 'project/project-helpdesk-tasks-form.dto',
  /** Projects page response body */
  PROJECT_PAGE_FIND_DTO = 'project/project-page-find.dto',
  /** Project list APIs base filters */
  PROJECT_LIST_FILTERS_DTO = 'project/project-list-filters.dto',
  /** Project list APIs common query parameters */
  PROJECT_LIST_QUERY_DTO = 'project/project-list-query.dto',
  /** Project partial update API request body */
  PROJECT_PARTIAL_UPDATE_DTO = 'project/project-partial-update.dto',
  /** Project simplified list API request body */
  PROJECT_SIMPLIFIED_LIST_QUERY_DTO = 'project/project-simplified-list-query.dto',
  /** Project workflow actions' APIs response body */
  PROJECT_WORKFLOW_ACTION_RESULT_DTO = 'project/project-workflow-action-result.dto',
  /** Project workflow APIs permissions for current authorized user */
  PROJECT_WORKFLOW_PERMISSIONS_DTO = 'project/project-workflow-permissions.dto',
  /** Projects template response body */
  PROJECT_TEMPLATE_FIND_DTO = 'project/project-template-find.dto',
  /** Project template create and update APIs request body */
  PROJECT_TEMPLATE_FORM_DTO = 'project/project-template-form.dto',
  /** Project time report target entity (project, HD task etc.) response body */
  PROJECT_TIME_REPORT_ENTITY_DTO = 'project/project-time-report-entity.dto',
  /** Project time report item status response body */
  PROJECT_TIME_REPORT_ITEM_STATUS_DTO = 'project/project-time-report-item-status.dto',
  /** Project time report item response body */
  PROJECT_TIME_REPORT_ITEMS_DTO = 'project/project-time-report-items.dto',
  /** Project time report plot line response body */
  PROJECT_TIME_REPORT_PLOT_LINE_DTO = 'project/project-time-report-plot-line.dto',
  /** Project time report plot response body */
  PROJECT_TIME_REPORT_PLOT_DTO = 'project/project-time-report-plot.dto',
  /** Project time report API query parameters */
  PROJECT_TIME_REPORT_QUERY_DTO = 'project/project-time-report-query.dto',
  /** Project time report summary row response body */
  PROJECT_TIME_REPORT_SUMS_DTO = 'project/project-time-report-sums.dto',
  /** Project time report response body */
  PROJECT_TIME_REPORT_RESULT_DTO = 'project/project-time-report-result.dto',
  /** Checklist response body */
  CHECKLIST_FIND_DTO = 'project/checklist-find.dto',
  /** Checklist finish API request body */
  CHECKLIST_FINISH_DTO = 'project/checklist-finish.dto',
  /** Checklist create and update APIs request body */
  CHECKLIST_FORM_DTO = 'project/checklist-form.dto',
  /** Checklist create and update APIs extended request body with project */
  CHECKLIST_FORM_WITH_PROJECT_DTO = 'project/checklist-form-with-project.dto',
  /** Checklist reopen API request body */
  CHECKLIST_REOPEN_DTO = 'project/checklist-reopen.dto',
  /** Checklist reschedule API request body */
  CHECKLIST_RESCHEDULE_DTO = 'project/checklist-reschedule.dto',
  /** Checklist template response body */
  CHECKLIST_TEMPLATE_FIND_DTO = 'project/checklist-template-find.dto',
  /** Checklist template create and update APIs request body */
  CHECKLIST_TEMPLATE_FORM_DTO = 'project/checklist-template-form.dto',
  /** Checklist type response body */
  CHECKLIST_TYPE_FIND_DTO = 'project/checklist-type-find.dto',
  /** Checklist type create and update APIs request body */
  CHECKLIST_TYPE_FORM_DTO = 'project/checklist-type-form.dto',
  /** Sub-project default values response body */
  SUBPROJECT_DEFAULTS_FIND_DTO = 'project/subproject-defaults-find.dto',
  /** Sub-project default values created and update requests body */
  SUBPROJECT_DEFAULTS_FORM_DTO = 'project/subproject-defaults-form.dto',
  /** Project status list APIs base filters */
  STATUS_FILTERS_DTO = 'project/status-filters.dto',
  /** Project status response body */
  STATUS_FIND_DTO = 'project/status-find.dto',
  /** Project status create and update APIs request body */
  STATUS_FORM_DTO = 'project/status-form.dto',
  /** Project status list API response body */
  STATUS_PAGE_DTO = 'project/status-page.dto',
  /** Project status list APIs query parameters */
  STATUS_QUERY_DTO = 'project/status-query.dto',
}
